export const PHONE_RE = /^(\+\d{12}|\d{10})$/;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const IFSC_RE  = /^[A-Z]{4}0[A-Z0-9]{6}$/;

export function validatePhone(v) {
  if (!v) return null; // optional
  return PHONE_RE.test(v.replace(/\s/g, '')) ? null : 'Invalid phone number';
}

export function validateEmail(v) {
  if (!v) return null; // optional
  return EMAIL_RE.test(v) ? null : 'Invalid email address';
}

export function validateGSTINFormat(v) {
  if (!v) return null; // optional
  return GSTIN_RE.test(v) ? null : 'GSTIN must be 15 chars: 22AAAAA0000A1Z5';
}

export function validateIFSC(v) {
  if (!v) return null;
  return IFSC_RE.test(v) ? null : 'Invalid IFSC code';
}

// Returns array of error strings. Empty = all good.
export function validateInvoice(invoice) {
  const errors = [];
  const { business, customer, lineItems } = invoice;

  if (!business.name?.trim())          errors.push('Business name is required');
  if (business.gstin && !GSTIN_RE.test(business.gstin)) errors.push('Business GSTIN is invalid');
  if (business.phone && validatePhone(business.phone))   errors.push('Business phone is invalid');
  if (business.email && validateEmail(business.email))   errors.push('Business email is invalid');

  if (!customer.name?.trim())          errors.push('Customer name is required');
  if (!customer.phone?.trim())         errors.push('Customer phone is required');
  if (customer.gstin && !GSTIN_RE.test(customer.gstin)) errors.push('Customer GSTIN is invalid');
  if (customer.phone && validatePhone(customer.phone))   errors.push('Customer phone is invalid');
  if (customer.email && validateEmail(customer.email))   errors.push('Customer email is invalid');

  if (!lineItems?.length)              errors.push('Add at least one line item');
  if (lineItems?.every(l => !l.description?.trim())) errors.push('At least one line item needs a description');

  return errors;
}
